import { useId } from "react";

import { cn } from "@/lib/utils";

export function DislikeIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-10", className)}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="20" cy="20" fill={`url(#${id})`} r="20" />
      <path
        clipRule="evenodd"
        d="M24.667 22.333v-8.204c0-.447.372-.819.821-.819h3.69c.45 0 .822.369.822.819v8.204c0 .45-.372.822-.822.822h-3.69a.827.827 0 01-.821-.822zm-12.716 2.463h3.55c-.294 1.18-1.088 1.63-1.088 3.28 0 3.01 3.43 5.578 4.294.949.258-1.247 3.095-5.758 4.357-5.857.425-.04.781-.397.781-.822v-8.217c0-.45-.384-.806-.818-.819-.45-.015-1.219-.282-2.025-.564-1.386-.474-3.116-1.079-4.949-1.079-2.378 0-5.07-.442-4.803 2.916C10 15 9.03 16.891 10 18.333c-1.25 1.25-1.026 2.493 0 3.75 0 0-.833 2.084 1.951 2.713z"
        fill="#007099"
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="6.286"
          x2="34.286"
          y1="34.286"
          y2="6.286"
        >
          <stop offset="0.354" stopColor="#41c9fa" />
          <stop offset="1" stopColor="#7076f7" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function LikeIcon({ className, ...props }: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-10", className)}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="20" cy="20" fill={`url(#${id})`} r="20" />
      <path
        clipRule="evenodd"
        d="M15.31 18.374v8.204a.827.827 0 01-.82.819H10.8a.824.824 0 01-.822-.82v-8.203c0-.45.372-.822.821-.822h3.69c.45 0 .822.372.822.822zm12.716-2.464h-3.55c.295-1.18 1.089-1.63 1.089-3.28 0-3.01-3.43-5.578-4.295-.948-.257 1.246-3.094 5.758-4.356 5.857-.425.04-.782.397-.782.821v8.217c0 .45.385.806.819.819.45.015 1.218.282 2.025.564 1.386.475 3.116 1.08 4.948 1.08 2.379 0 5.07.441 4.804-2.917 1.25-.417 2.219-2.308 1.25-3.75 1.25-1.25 1.026-2.493 0-3.75 0 0 .833-2.083-1.952-2.712z"
        fill="#aa7500"
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="36.375"
          x2="9.864"
          y1="6.857"
          y2="22.669"
        >
          <stop stopColor="#fa7e4a" />
          <stop offset="1" stopColor="#ffc850" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function LoveIcon({ className, ...props }: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-10", className)}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="20" cy="20" fill={`url(#${id})`} r="20" />
      <path
        d="M19.86 29.3c.354 0 .892-.328 1.414-.681 4.543-3.02 7.613-6.654 7.613-10.289 0-3.525-2.481-5.83-5.308-5.83-1.767 0-2.995.967-3.719 2.33-.715-1.354-1.951-2.33-3.718-2.33-2.827 0-5.309 2.305-5.309 5.83 0 3.635 3.071 7.269 7.614 10.289.522.353 1.06.681 1.413.681z"
        fill="#8e2c2b"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="34.857"
          x2="5.714"
          y1="6.286"
          y2="33.714"
        >
          <stop stopColor="#f74746" />
          <stop offset="1" stopColor="#fc994c" />
        </linearGradient>
      </defs>
    </svg>
  );
}
